import { Card } from 'flowbite-react';
import {
  DataContainer,
  FilterDropdown,
  formatNumber,
  Separator,
  GroupedList,
  PaginationWithEllipsis,
} from '@acme/foundation';
import { Icon } from '@acme/assets';
import { useState } from 'react';
import { WalletCard, WalletCardProps } from './walletCard';

type WalletsInfoProps = {
  balance: number;
  wallets: WalletCardProps[];
};

const maxVisibleWallets = 6;

export const WalletsInfo = (props: WalletsInfoProps) => {
  const [groupValue, setGroupValue] = useState<string | undefined>('free');

  const typesWallets = [
    { name: 'Активные', value: 2 },
    { name: 'В продаже', value: 4 },
  ];

  const error = false;

  return (
    <Card className="flex flex-col gap-6">
      <div className="grid grid-cols-[1fr_1px_1fr] gap-6">
        <div className="flex flex-col gap-1">
          <span className="text-gray-700">Всего средств</span>

          <div className="flex gap-2 items-center">
            <Icon name="ruble-sign" className="text-gray-500" />
            <span className="text-gray-900 font-bold text-2xl">
              {formatNumber(props.balance)}
            </span>
          </div>
        </div>

        <Separator vertical />

        <div className="flex flex-col gap-1">
          <span className="text-gray-700">Криптокошельки</span>

          <div className="flex gap-4">
            {typesWallets.map((item) => (
              <div key={item.name} className="flex gap-2 text-2xl">
                <span className="text-gray-500">{item.name}:</span>
                <span className="font-bold">{formatNumber(item.value)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Separator />

      <div className="flex flex-col gap-6">
        <div className="flex gap-2 justify-between w-full">
          <h2 className="text-xl font-semibold">Добавленные криптокошельки</h2>
          <FilterDropdown
            options={[
              { value: 'free', label: 'Свободно' },
              { value: 'application', label: 'По заявкам' },
            ]}
            title="Группировка"
            value={groupValue}
            onChange={setGroupValue}
          />
        </div>

        <DataContainer
          loading={false}
          error={{
            view: error,
            title: 'Не удалось загрузить страницу',
            message: 'Попробуйте повторить позднее',
            button: {
              title: 'Перезагрузить страницу',
              onClick: () => {
                window.location.reload();
              },
            },
          }}
          empty={{
            view: !props.wallets.length,
            title: 'Не найдено ни одного кошелька',
          }}
          className="min-h-[394px] flex gap-[inherit] flex-col"
        >
          <GroupedList
            groups={[
              {
                key: 'free',
                label: '',
                items: props.wallets,
                className:
                  'grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4',
              },
            ]}
            renderGroupHeader={(group) => {
              if (!group.label) {
                return null;
              }

              return (
                <div className="pb-3 border-b border-gray-200">
                  <span className="text-gray-900 font-semibold text-xl">
                    {group.label}
                  </span>
                </div>
              );
            }}
            renderItem={(item) => (
              <WalletCard key={item.walletAddress} {...item} />
            )}
          />

          {props.wallets.length < maxVisibleWallets && (
            <PaginationWithEllipsis
              currentPage={1}
              total={200}
              onChange={() => {}}
            />
          )}
        </DataContainer>
      </div>
    </Card>
  );
};
